import { autoinject, computedFrom } from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { UsersLocationsController } from 'screens/administration/locations/users-locations-controller';
import { AfSplitCustomElement } from 'framework/html_behaviors/af-split';
import { LocalStorageService } from 'services/local-storage-service';
import { MapZonesController } from './map-zones-controller';

@autoinject
export class AdminLocationsScreenIndex {
  router: Router;
  private splitter: AfSplitCustomElement;
  private xSmallBreakpoint = 576;

  private adminLocationsScreenKey = 'AdminLocationsScreen';
  private usersLocationsTabKey = 'UsersLocations';
  private mapZonesTabKey = 'MapZones';
  private splitterPercentFirstKey = 'AdminLocationsScreen:splitter:percentFirst';
  private splitterPercentSecondKey = 'AdminLocationsScreen:splitter:percentSecond';
  private splitterPercentDirectionKey = 'AdminLocationsScreen:splitter:direction';

  constructor(private usersLocationsController: UsersLocationsController, private mapZonesController: MapZonesController, private localStorageService: LocalStorageService) {
    this.usersLocationsController.setSplitter = () => this.setSplitter(this.usersLocationsTabKey);
    this.usersLocationsController.storeSplitter = () => this.storeSplitter(this.usersLocationsTabKey);
    this.mapZonesController.setSplitter = () => this.setSplitter(this.mapZonesTabKey);
    this.mapZonesController.storeSplitter = () => this.storeSplitter(this.mapZonesTabKey);
  }

  async attached() {
    await this.usersLocationsController.attach();
    await this.mapZonesController.attach();
  }

  detached() {
    this.usersLocationsController.detach();
    this.mapZonesController.detach();
  }

  private setSplitter(tabKey: string) {
    this.splitter.percentFirst = this.localStorageService.getItem(this.getSplitterStorageKey(tabKey, this.splitterPercentFirstKey), window.screen.width < this.xSmallBreakpoint ? 60 : 50);
    this.splitter.percentSecond = this.localStorageService.getItem(this.getSplitterStorageKey(tabKey, this.splitterPercentSecondKey), window.screen.width < this.xSmallBreakpoint ? 40 : 50);
    this.splitter.direction = this.localStorageService.getItem(this.getSplitterStorageKey(tabKey, this.splitterPercentDirectionKey), window.screen.width < this.xSmallBreakpoint ? 'vertical' : 'horizontal');
    this.splitter.minsizeFirst = this.splitter.minsizeSecond = window.screen.width < this.xSmallBreakpoint ? 100 : 300;
    this.splitter.refresh();
  }

  private storeSplitter(tabKey: string) {
    this.localStorageService.setItem(this.getSplitterStorageKey(tabKey, this.splitterPercentFirstKey), this.splitter.percentFirst);
    this.localStorageService.setItem(this.getSplitterStorageKey(tabKey, this.splitterPercentSecondKey), this.splitter.percentSecond);
    this.localStorageService.setItem(this.getSplitterStorageKey(tabKey, this.splitterPercentDirectionKey), this.splitter.direction);
  }

  private getSplitterStorageKey(tabKey: string, splitterKey: string): string {
    return `${this.adminLocationsScreenKey}:${tabKey}:${splitterKey}`;
  }

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      { route: '', redirect: 'users-locations' },
      { route: 'users-locations', viewPorts: { list: { moduleId: 'screens/administration/locations/users-locations-list' }, toolbar: { moduleId: 'components/locations/users-locations-clear-filters-toolbar' }, map: { moduleId: 'screens/administration/locations/users-locations-map' } }, name: 'users-locations', title: 'Users locations', activationStrategy: 'replace', nav: true },
      { route: 'map-zones', viewPorts: { list: { moduleId: 'screens/administration/locations/map-zones-list' }, toolbar: { moduleId: 'components/locations/map-zones-clear-filters-toolbar' }, map: { moduleId: 'screens/administration/locations/map-zones-map' } }, name: 'map-zones', title: 'Zones', activationStrategy: 'replace', nav: true }
    ]);

    this.router = router;
  }

  @computedFrom('usersLocationsController.taskCounter.runningCount', 'mapZonesController.taskCounter.runningCount')
  get reloading() {
    return this.usersLocationsController.taskCounter.runningCount > 0 || this.mapZonesController.taskCounter.runningCount > 0;
  }
}
